angular.module('zc.master.zcliteInvoices', [
  'zc.master'
])



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_invoices/index.coffee